export default __webpack_public_path__ + "static/media/latreqi_banner.3edb4e2a.png";